/**
 * Created by r4zi4l on 15.09.2021
 */

const Map2dAdviceClickLogic = function (options) {
    Map2dAdviceBaseLogic.call(this, options);
};

Map2dAdviceClickLogic.prototype = Object.create(Map2dAdviceBaseLogic.prototype);
Map2dAdviceClickLogic.prototype.constructor = Map2dAdviceClickLogic;

Map2dAdviceClickLogic.prototype.findMove = function () {
    const unit = this.listAvailableUnits()[0];

    if (unit) {
        const infoOpen = InfoView.IsDisplayedFor(unit);
        const cell = cc.p(unit.x, unit.y);
        return {
            cells: [cell],
            highlight: !infoOpen && [cell],
            arrow: !infoOpen && cell,
            unitView: infoOpen && ["click"]
        };
    }
};
